import React, { useState } from 'react';
import { AlertCircle, ChevronUp, ChevronDown } from 'lucide-react';

interface ValidationError {
  nodeId?: string;
  message: string;
  type: 'error' | 'warning';
}

interface CanvasValidationProps {
  errors: ValidationError[];
  className?: string;
}

export function CanvasValidation({ errors, className = '' }: CanvasValidationProps) {
  const [showValidation, setShowValidation] = useState(false);

  if (errors.length === 0) return null;

  return (
    <div 
      className={`relative ${className}`}
      onMouseEnter={() => setShowValidation(true)}
      onMouseLeave={() => setShowValidation(false)}
    >
      <button className="flex items-center gap-2 px-3 py-1.5 bg-yellow-500/10 text-yellow-500 rounded-lg hover:bg-yellow-500/20 transition-colors">
        <AlertCircle className="w-4 h-4" />
        <span className="text-sm font-medium">
          {errors.length} {errors.length === 1 ? 'Issue' : 'Issues'}
        </span>
        {showValidation ? (
          <ChevronUp className="w-3.5 h-3.5" />
        ) : (
          <ChevronDown className="w-3.5 h-3.5" />
        )}
      </button>

      {showValidation && (
        <div className="absolute top-full right-0 mt-2 w-80 p-3 bg-gray-800 rounded-lg border border-gray-700 shadow-xl z-50">
          <ul className="space-y-2">
            {errors.map((error, index) => (
              <li
                key={index}
                className={`flex items-start gap-2 text-sm ${
                  error.type === 'error' ? 'text-red-400' : 'text-yellow-400'
                }`}
              >
                <AlertCircle className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <span>{error.message}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
